import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-overview-tab-1-part',
	standalone: true,
	templateUrl: './delivery-overview-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./delivery-overview-tab-1.part.scss`],
})
export class DeliveryOverviewTab1Part {
}
